import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationDeleteWorkspaceArgs, BackendWorkspace } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteWorkspace($id: ID!) {
    deleteWorkspace(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteWorkspaceArgs;
type Result = Pick<BackendWorkspace, 'id'>;

export const deleteWorkspace = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
